import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';

import Checkboxes from './Checkboxes';
import { KD_STATE, KD_COUNTRY } from '../../constants';

class CheckboxesButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = { open: false };
  }

  toggle = open => {
    this.setState(Object.assign({}, this.state, { open }));
  };

  render() {
    const { type, theme, isInputVisible } = this.props;

    if (!(type === KD_STATE || type === KD_COUNTRY)) {
      return null;
    }

    return (
      <div
        className={classNames(
          'c-kd-select-geography__checkboxes-buttons',
          theme['c-kd-select-geography__checkboxes-buttons'],
          {
            'c-kd-select-geography__checkboxes-buttons--with-mainselector': isInputVisible,
            [theme[
              'c-kd-select-geography__checkboxes-buttons--with-mainselector'
            ]]: isInputVisible,
          },
        )}
      >
        <button
          className={classNames(
            'c-kd-select-geography__checkboxes-button',
            theme['c-kd-select-geography__checkboxes-button'],
          )}
          onClick={event => {
            event.preventDefault();
            this.toggle(true);
          }}
        />
        <div
          onClick={() => this.toggle(false)}
          className={classNames(
            'c-kd-select-geography__overlay',
            { 'u-hidden': !this.state.open },
            theme['c-kd-select-geography__overlay'],
            { [theme['u-hidden']]: !this.state.open },
          )}
        />
        <div
          className={classNames(
            'c-kd-select-geography__popup-container',
            { 'u-hidden': !this.state.open },
            theme['c-kd-select-geography__popup-container'],
            { [theme['u-hidden']]: !this.state.open },
          )}
        >
          <Checkboxes {...this.props} />
        </div>
      </div>
    );
  }
}

CheckboxesButton.propTypes = {
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
  type: PropTypes.string,
};

export default CheckboxesButton;



// WEBPACK FOOTER //
// ./app/components/KdSelectGeography/CheckboxesButton.js